var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',[_c('div',{staticClass:"toast-mask"}),_c('div',{staticClass:"toast"},[_c('div',{staticClass:"row center v-center",staticStyle:{"height":"60px"}},[_c('i',{staticClass:"weui-loading weui-icon_toast"})]),_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }